import React from "react";
import Marquee from "react-fast-marquee";

const items = [
  "SUBLIMATION T-SHIRTS",
  "UNIFORMS",
  "PROMOTIONAL MERCH",
  "COTTON BLANKS · 22 SHADES",
  "CUSTOM POLOS · EMBROIDERY",
  "FLEECE HOODIES",
  "OVERSIZED · 11 SHADES",
  "BOILER SUITS",
  "SAFETY JACKETS · HI-VIZ",
  "CARGO TROUSERS",
  "WINDCHEATERS",
  "BULK ORDERS",
  "FAST TURNAROUND",
];

export default function MarqueeStrip() {
  return (
    <div
      className="bg-black text-[#FFE600] border-y-4 border-black py-5"
      data-testid="marquee-strip"
    >
      <Marquee speed={60} gradient={false} pauseOnHover>
        {items.map((t, i) => (
          <span
            key={i}
            className="font-marquee uppercase text-3xl md:text-5xl lg:text-6xl mx-8 flex items-center gap-8"
          >
            {t}
            <span className="inline-block w-5 h-5 rounded-full bg-[#FF0055]" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
